/**
 * Fixed style defaults for "stroke-only frame" object types.
 *
 * 일부 타입(조명 프레임 / 존 / 외곽선)은 템플릿에서 가져올 때 좌측 속성 패널에서
 * 항상 "채우기 없음(stroke only)" + "선 두께 10px" 로 고정되어야 한다.
 *
 * 백엔드 ObjectType API 는 strokeWidth/fillColor/colorMode 를 저장하지 않으므로
 * (name/icon/color/priority/properties 만 영속), 이 스타일은 타입 이름 기준으로
 * loadTypes 재구성 시점에 파생시킨다. 그래야 템플릿 import 직후뿐 아니라
 * 에디터 재진입(loadTypes) 후에도 동일하게 유지된다.
 */

import type { ObjectType } from './types';

/** 채우기 없음 + 10px 로 고정할 타입 이름들(템플릿 displayName / zone 레거시 포함). */
export const STROKE_ONLY_TYPE_NAMES: readonly string[] = [
  '조명 프레임',
  '외곽선',
  '구역', // zone canonical
  '존', // zone legacy
  'Zone',
  'zone',
];

/** 고정 선 두께(px). */
export const STROKE_ONLY_WIDTH = 10;

/** 이름이 stroke-only 고정 대상인지 여부. */
export function isStrokeOnlyTypeName(name: string): boolean {
  return STROKE_ONLY_TYPE_NAMES.includes(name.trim());
}

/**
 * stroke-only 대상이면 채우기 없음 + 10px 스타일을 강제 적용한 새 객체를 반환한다.
 * 대상이 아니면 원본을 그대로 반환한다. (불변 — 새 객체 반환)
 */
export function applyStrokeOnlyDefaults(type: ObjectType): ObjectType {
  if (!isStrokeOnlyTypeName(type.name)) return type;
  return {
    ...type,
    colorMode: 'stroke',
    fillColor: 'none',
    strokeColor: type.strokeColor || type.color || '#3b82f6',
    strokeWidth: STROKE_ONLY_WIDTH,
  };
}
